import name from './name'

const selectSliceData = state => state[name]
const selectCampaignList = state => selectSliceData(state).list
const selectTotal = state => selectSliceData(state).total
const lastKey = state => selectSliceData(state).lastKey

export {
  selectCampaignList,
  selectTotal,
  lastKey
}
